module.exports = __webpack_public_path__ + "img/SDG_16-deactivated.00608ce4.png";